/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Atelier_AudienceInputs */

const en_atelier_audience = /** @type {(inputs: Atelier_AudienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For brands and suppliers`)
};

/**
* | output |
* | --- |
* | "For brands and suppliers" |
*
* @param {Atelier_AudienceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const atelier_audience = /** @type {((inputs?: Atelier_AudienceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Atelier_AudienceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_atelier_audience(inputs)
});